function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "sound",
  transform: "translate(-356.347 -412.129)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_15",
  "data-name": "Path 15",
  d: "M273.547,472.454v1.734h.813l.813,1.063v-3.922l-.984,1.125h-.641",
  transform: "translate(83 -59)",
  fill: "none",
  stroke: "#1f1f1f",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 0.4
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_16",
  "data-name": "Path 16",
  d: "M276.219,472.484a1.831,1.831,0,0,1,.219.8,2.3,2.3,0,0,1-.219.859",
  transform: "translate(83 -59)",
  fill: "none",
  stroke: "#1f1f1f",
  strokeLinecap: "round",
  strokeWidth: 0.4
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_17",
  "data-name": "Path 17",
  d: "M276.219,472.484a2.172,2.172,0,0,1,0,2.875",
  transform: "translate(83.844 -59.594)",
  fill: "none",
  stroke: "#1f1f1f",
  strokeLinecap: "round",
  strokeWidth: 0.4
}));

function SvgSound(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 4.459,
    height: 4.322,
    viewBox: "0 0 4.459 4.322",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSound);
export default __webpack_public_path__ + "static/media/sound.7828a0d0.svg";
export { ForwardRef as ReactComponent };